export const canLoadScript = (config, scriptName) => {
  if (config?.scripts?.[scriptName]?.enabled) {
    return true;
  }
  return false;
};
